// STEP 1: Load Variables
// Global Variables
import Constants from './constants';

export const findDeckMarkerInDeckImg = (shipImage, canvasShipImg, startX, endX, startY, endY, isFrame) => {
  let Ship: any = {
    Deck: {
      StartPoint: {
        X: 0,
        Y: 0,
      },
      EndPoint: {
        X: 0,
        Y: 0,
      },
    },
    Zones: [
      {
        Zone: {
          ZoneNumber: 0,
          StartPoint: {
            X: 0,
            Y: 0,
          },
          EndPoint: {
            X: 0,
            Y: 0,
          },
        },
      },
    ],
    Frames: [
      {
        Frame: {
          ZoneNumber: 0,
          FrameNumber: 0,
          StartPoint: {
            X: 0,
            Y: 0,
          },
          EndPoint: {
            X: 0,
            Y: 0,
          },
        },
      },
    ],
    Center: {
      StartPoint: {
        X: 0,
        Y: 0,
      },
      EndPoint: {
        X: 0,
        Y: 0,
      },
    },
  };

  let FirstBlueMarker = {X: 0, Y: 0};
  let SecondBlueMarker = {X: 0, Y: 0};
  let FirstRedMarker = {X: 0, Y: 0};
  let SecondRedMarker = {X: 0, Y: 0};
  let FramePositions = [];
  let negativeFramePositions = [];
  let positiveFramePositions = [];
  let MarkerWidth = 5;
  let _x = 0;
  let _y = 0;

  let unit = 0;
  let progress = 0;
  let totalPixels = 0;
  let totalScannedPixels = 0;
  let progressive;
  let resolution = 'Low';
  let logInfo = '';

  let previewImageHeight = 0;
  let previewImageWidth = 0;
  // let isFrameRequired = isFrame;
  let isFrameRequired = 1;

  let _startPoint = 0;
  let _endPoint = 0;
  let _yPoint = 0;

  //ALLZONES Added array letiable to store all zone markers from image
  let BlueMarkers = [];
  let LastBlueMarker = {X: 0, Y: 0};

  startX = 0;
  endX = canvasShipImg.width;
  // $('.actionButton').css('display', 'none');

  startY = canvasShipImg.height * 0.45;
  endY = canvasShipImg.height * 0.55;

  //////////////////////////////////////////////////////////////////////
  // Detect deck information
  // console.log('Start scanning image to detect deck (green markers).');

  // set center 20% height to scan

  // find first green marker
  // console.log('Scanning for first green marker.');
  let c = canvasShipImg.getContext('2d');
  for (let _X = startX; _X <= endX; _X++) {
    for (let _Y = startY; _Y <= endY; _Y++) {
      // get color
      let pos = {x: _X, y: _Y};
      let p = c.getImageData(_X, _Y, 1, 1).data;
      let color = ('000000' + rgbToHex(p[0], p[1], p[2])).slice(-6);
      color = color.toUpperCase();

      // Get Green Start Color
      if (Constants.ColorGreen.indexOf(color) >= 0) {
        if (Ship.Deck.StartPoint.X == 0) {
          // this is first green markers
          Ship.Deck.StartPoint.X = _X + 1;
          Ship.Deck.StartPoint.Y = _Y;
          //break scanning after first green marker.
          break;
        }
      }
    }
    if (Ship.Deck.StartPoint.X > 0) {
      break;
    }
  }

  // find second marker
  // console.log('Scanning for second green marker.');
  if (Ship.Deck.StartPoint.X > 0) {
    // scan for deck end point

    for (let _X = Ship.Deck.StartPoint.X; _X <= endX; _X++) {
      //resume scanning for second green marker at same Y cordinate to avoid nested for loop.
      let _Y = Ship.Deck.StartPoint.Y + 15;

      // get color
      let pos = {x: _X, y: _Y};
      let p = c.getImageData(_X, _Y, 1, 1).data;
      let color = ('000000' + rgbToHex(p[0], p[1], p[2])).slice(-6);
      color = color.toUpperCase();

      // Get Green End Color
      if (Constants.ColorGreen.indexOf(color) >= 0) {
        if (Ship.Deck.StartPoint.X > 0 && Ship.Deck.StartPoint.X + MarkerWidth < _X) {
          // this is second green markers
          Ship.Deck.EndPoint.X = _X;
          Ship.Deck.EndPoint.Y = _Y;
          break;
        }
      }
    }
  }

  if (Ship.Deck.StartPoint.X > 0 && Ship.Deck.EndPoint.X > 0) {
    // console.log(
    //   'deck found start:end = ' +
    //     Ship.Deck.StartPoint.X +
    //     ':' +
    //     Ship.Deck.EndPoint.X +
    //     '...'
    // );
    // console.log('Scanning for zones between ' + startX + ' to ' + endX + '...');

    /////////////////////////////////////////////////////////////////////////////
    // Deck found, Now continue to detect Zones
    let deckLength = Ship.Deck.EndPoint.X - Ship.Deck.StartPoint.X;
    let ZonesCountManual: any = null;
    ZonesCountManual = prompt(
      `Please enter the deck's number of zones. If you are unsure about it, leave the prompt empty and click the "OK'' button and the zone number will be automatically calculated. Total Zones = (Deck end point - Deck start point)/Zone length.`
    );

    if (ZonesCountManual != '') {
      //Zone Values manually provided, no need to scan bluw markers

      let numberOfZonePixels = deckLength;
      let ZoneCount = 1;

      // Add first Zone Image start to Deck start point
      Ship.Zones[0].Zone.ZoneNumber = ZoneCount;
      Ship.Zones[0].Zone.StartPoint.X = 1;
      Ship.Zones[0].Zone.StartPoint.Y = Ship.Deck.StartPoint.Y;
      Ship.Zones[0].Zone.EndPoint.X = Ship.Deck.StartPoint.X;
      Ship.Zones[0].Zone.EndPoint.Y = Ship.Deck.StartPoint.Y;

      // calculate zone between deck start to deck end

      let averageZoneLength = 0;
      let numberOfRemZonePixels = 0;
      let zoneStart = 0;
      let zoneEnd = 0;
      let tempNumberOfZones = 0;

      let ZonePositions = [];

      for (let z = 1; z <= ZonesCountManual; z++) {
        tempNumberOfZones = ZonesCountManual - z + 1;

        if (z == 1) {
          averageZoneLength = deckLength / tempNumberOfZones;
        } else {
          averageZoneLength = numberOfRemZonePixels / tempNumberOfZones;
        }

        zoneEnd = zoneStart + Math.floor(averageZoneLength);
        zoneEnd = zoneEnd - 1;

        // collect frame positions in temporary array
        ZonePositions.push(zoneStart + Ship.Deck.StartPoint.X);
        zoneStart = zoneEnd + 1;

        numberOfRemZonePixels = deckLength - zoneStart;
      }

      if (ZonePositions.length > 0) {
        for (let _F = 1; _F <= ZonePositions.length; _F++) {
          _startPoint = ZonePositions[_F - 1];
          _endPoint = ZonePositions[_F];
          ZoneCount++;

          if (_endPoint > Ship.Deck.EndPoint.X || _F == ZonePositions.length) _endPoint = Ship.Deck.EndPoint.X;

          // add other frame elements to json result
          Ship.Zones.push({
            Zone: {
              ZoneNumber: ZoneCount,
              StartPoint: {
                X: _startPoint + 1,
                Y: Ship.Deck.StartPoint.Y,
              },
              EndPoint: {
                X: _endPoint,
                Y: Ship.Deck.StartPoint.Y,
              },
            },
          });
        }
      }

      // Add last Zone Image start to Deck start point
      Ship.Zones.push({
        Zone: {
          ZoneNumber: ZoneCount + 1,
          StartPoint: {
            X: Ship.Deck.EndPoint.X + 1,
            Y: Ship.Deck.StartPoint.Y,
          },
          EndPoint: {
            X: shipImage.width,
            Y: Ship.Deck.StartPoint.Y,
          },
        },
      });
    } else {
      /* PROMPT LOGIC FOR ZONE - END */
      // Work everything as it is here if no zone value given in prompt
      startX = Ship.Deck.StartPoint.X;
      endX = Ship.Deck.EndPoint.X;

      // set bottom 80% to 90% section to scan
      startY = Number(canvasShipImg.height * 0.8);
      endY = Number(canvasShipImg.height * 0.9);

      // find first marker
      // console.log('Scanning for first blue marker.');
      let c = canvasShipImg.getContext('2d');
      for (let _X = startX; _X <= endX; _X++) {
        for (let _Y = startY; _Y <= endY; _Y++) {
          // get color
          let pos = {x: _X, y: _Y};
          let p = c.getImageData(_X, _Y, 1, 1).data;
          let color = ('000000' + rgbToHex(p[0], p[1], p[2])).slice(-6);
          color = color.toUpperCase();

          // Get Blue Start Color
          if (Constants.ColorBlue.indexOf(color) >= 0) {
            if (FirstBlueMarker.X == 0) {
              //ALLZONES if FirstBlueMarker.X and Deck.StartPoint.X is not same then First Zone start point is Deck.StartPoint.X
              if (FirstBlueMarker.X != Ship.Deck.StartPoint.X) {
                BlueMarkers.push({
                  X: Ship.Deck.StartPoint.X,
                  Y: Ship.Deck.StartPoint.Y,
                });
              }
              //ALLZONES Add current marker as another zone in array
              BlueMarkers.push({X: _X + 1, Y: _Y});

              FirstBlueMarker = {X: _X + 1, Y: _Y};
              break;
            }
          }
        }
        if (FirstBlueMarker.X > 0) {
          break;
        }
      }

      // find second marker
      // console.log('Scanning for second blue marker.');
      if (FirstBlueMarker.X > 0) {
        let c = canvasShipImg.getContext('2d');
        for (let _X = FirstBlueMarker.X; _X <= endX; _X++) {
          let _Y = FirstBlueMarker.Y + 15;

          // get color
          let pos = {x: _X, y: _Y};
          let p = c.getImageData(_X, _Y, 1, 1).data;
          let color = ('000000' + rgbToHex(p[0], p[1], p[2])).slice(-6);
          color = color.toUpperCase();

          // Get Blue End Color
          if (Constants.ColorBlue.indexOf(color) >= 0) {
            if (FirstBlueMarker.X > 0 && FirstBlueMarker.X + MarkerWidth < _X) {
              //ALLZONES Add current marker as another zone in array
              BlueMarkers.push({X: _X, Y: _Y});

              SecondBlueMarker = {X: _X, Y: _Y};
              break;
            }
          }
        }
      }

      //ALLZONES Scan image till end to find more zone marker
      if (SecondBlueMarker.X > 0) {
        for (let _X = SecondBlueMarker.X + MarkerWidth; _X <= shipImage.width; _X++) {
          // let _Y = SecondBlueMarker.Y + MarkerWidth;
          let _Y = FirstBlueMarker.Y + 15; // increse 15px

          // get color
          let pos = {x: _X, y: _Y};
          let p = c.getImageData(_X, _Y, 1, 1).data;
          let color = ('000000' + rgbToHex(p[0], p[1], p[2])).slice(-6);
          color = color.toUpperCase();

          // Get Blue End Color
          if (Constants.ColorBlue.indexOf(color) >= 0) {
            //ALLZONES Add current marker as another zone in array
            BlueMarkers.push({X: _X, Y: _Y});

            LastBlueMarker = {X: _X, Y: _Y};
            _X = _X + MarkerWidth;
          }
        }
      }

      //ALLZONES if LastBlueMarker.X is earlier than Deck.EndPoint.X then Last Zone end point is Deck.EndPoint.X
      if (LastBlueMarker.X + MarkerWidth < Ship.Deck.EndPoint.X) {
        BlueMarkers.push({X: Ship.Deck.EndPoint.X, Y: Ship.Deck.EndPoint.Y});
      }

      // console.log(BlueMarkers.length + ':' + LastBlueMarker.X);

      if (FirstBlueMarker.X > 0 && SecondBlueMarker.X > 0) {
        // console.log(
        //   'zone markers found at ' +
        //     FirstBlueMarker.X +
        //     ':' +
        //     SecondBlueMarker.X +
        //     '...'
        // );
        // console.log('Count and locate all the zones now.');

        //ALLZONES If more than two blue markers found than use new logic, otherwise use same old logic to prepare json

        if (LastBlueMarker.X == 0) {
          // Same old logic with two additional zones at start and end
          let BlueLaneDistance = SecondBlueMarker.X - FirstBlueMarker.X;

          let _zoneNumber = 1;
          _yPoint = FirstBlueMarker.Y;

          // add first zone element to json result image start to deck start point
          Ship.Zones[0].Zone.ZoneNumber = _zoneNumber;
          Ship.Zones[0].Zone.StartPoint.X = 1;
          Ship.Zones[0].Zone.StartPoint.Y = _yPoint;
          Ship.Zones[0].Zone.EndPoint.X = Ship.Deck.StartPoint.X - 1;
          Ship.Zones[0].Zone.EndPoint.Y = _yPoint;

          _zoneNumber++;
          _startPoint = Ship.Deck.StartPoint.X;
          _endPoint = FirstBlueMarker.X; //_startPoint + BlueLaneDistance;

          // add second zone element to json result deck start point to first blue marker
          Ship.Zones.push({
            Zone: {
              ZoneNumber: _zoneNumber,
              StartPoint: {
                X: _startPoint,
                Y: _yPoint,
              },
              EndPoint: {
                X: _endPoint,
                Y: _yPoint,
              },
            },
          });

          for (let _Z = _endPoint + 1; _Z < Ship.Deck.EndPoint.X; _Z++) {
            _zoneNumber++;
            _startPoint = _Z;
            _endPoint = _startPoint + BlueLaneDistance;
            if (_endPoint > Ship.Deck.EndPoint.X) _endPoint = Ship.Deck.EndPoint.X;

            // add other zone elements to json result
            Ship.Zones.push({
              Zone: {
                ZoneNumber: _zoneNumber,
                StartPoint: {
                  X: _startPoint,
                  Y: _yPoint,
                },
                EndPoint: {
                  X: _endPoint,
                  Y: _yPoint,
                },
              },
            });

            _Z = _endPoint;
          }
          // add last zone element to json result deck end point to image width
          Ship.Zones.push({
            Zone: {
              ZoneNumber: _zoneNumber + 1,
              StartPoint: {
                X: _endPoint + 1,
                Y: _yPoint,
              },
              EndPoint: {
                X: shipImage.width,
                Y: _yPoint,
              },
            },
          });
        } else {
          //ALLZONES More than 2 blue markers -> add new logic to detect zone
          let _zoneNumber = 1;
          _startPoint = 1;
          _endPoint = BlueMarkers[0].X;
          _yPoint = FirstBlueMarker.Y;
          // add first zone element to json result
          Ship.Zones[0].Zone.ZoneNumber = _zoneNumber;
          Ship.Zones[0].Zone.StartPoint.X = _startPoint;
          Ship.Zones[0].Zone.StartPoint.Y = _yPoint;
          Ship.Zones[0].Zone.EndPoint.X = _endPoint - 1;
          Ship.Zones[0].Zone.EndPoint.Y = _yPoint;

          for (let _Z = 0; _Z < BlueMarkers.length - 1; _Z++) {
            _zoneNumber++;
            _startPoint = BlueMarkers[_Z].X;
            _endPoint = BlueMarkers[_Z + 1].X - 1;

            // add other zone elements to json result
            Ship.Zones.push({
              Zone: {
                ZoneNumber: _zoneNumber,
                StartPoint: {
                  X: _startPoint,
                  Y: _yPoint,
                },
                EndPoint: {
                  X: _endPoint,
                  Y: _yPoint,
                },
              },
            });
          }
          // add last zone element to json result
          Ship.Zones.push({
            Zone: {
              ZoneNumber: _zoneNumber + 1,
              StartPoint: {
                X: _endPoint + 1,
                Y: _yPoint,
              },
              EndPoint: {
                X: shipImage.width,
                Y: _yPoint,
              },
            },
          });
        }
      }
    }
    if (Object.keys(Ship.Zones[0].Zone).length > 1) {
      console.log('Scanning for frames between ' + startX + ' to ' + endX + '...');

      // console.log(
      //   'Scanning for frames between ' + startX + ' to ' + endX + '...'
      // );
      /////////////////////////////////////////////////////////////////////////////
      // Continue to detect Frames only if deck and zone found
      startX = 0;
      endX = shipImage.width;

      // set center 20% height to scan
      startY = Number(canvasShipImg.height * 0.45);
      endY = Number(canvasShipImg.height * 0.55);

      // find first marker
      // console.log('Scanning for first red marker.');
      let c = canvasShipImg.getContext('2d');
      for (let _X = startX; _X <= endX; _X++) {
        for (let _Y = startY; _Y <= endY; _Y++) {
          // get color

          let p = c.getImageData(_X, _Y, 1, 1).data;
          let color = ('000000' + rgbToHex(p[0], p[1], p[2])).slice(-6);
          color = color.toUpperCase();

          // Get Red Start Color
          if (Constants.ColorRed.indexOf(color) >= 0) {
            if (FirstRedMarker.X == 0) {
              FirstRedMarker = {X: _X, Y: _Y};
              break;
            }
          }
        }
        if (FirstRedMarker.X > 0) {
          break;
        }
      }

      // find second marker
      // console.log('Scanning for second red marker.');

      if (FirstRedMarker.X > 0) {
        for (let _X = FirstRedMarker.X; _X <= endX; _X++) {
          for (let _Y = FirstRedMarker.Y + 2; _Y <= endY; _Y++) {
            // get color
            let p = c.getImageData(_X, _Y, 1, 1).data;
            let color = ('000000' + rgbToHex(p[0], p[1], p[2])).slice(-6);
            color = color.toUpperCase();

            // Get Green End Color
            if (Constants.ColorRed.indexOf(color) >= 0) {
              if (FirstRedMarker.X > 0 && FirstRedMarker.X + MarkerWidth < _X) {
                SecondRedMarker = {X: _X, Y: _Y};
                break;
              }
            }
          }
          if (SecondRedMarker.X > 0) {
            break;
          }
        }
      }

      if (FirstRedMarker.X > 0 && SecondRedMarker.X > 0) {
        /////////////////////////////////////////////////////////////////////////////
        // Frame markes found, Now continue to detect frame positions

        // console.log(
        //   'frame markers found at ' +
        //     FirstRedMarker.X +
        //     ':' +
        //     SecondRedMarker.X +
        //     '...'
        // );
        // console.log('Count and locate all the frames now.');

        // let deckLength = Ship.Deck.EndPoint.X - Ship.Deck.StartPoint.X;
        let deckLength: any = canvasShipImg.width;

        let frameLength = SecondRedMarker.X - FirstRedMarker.X;
        let totalFrames: any = null;

        if (isFrameRequired === 1) {
          totalFrames = prompt(
            `Please enter the deck's number of frames. If you are unsure about it, leave the prompt empty and click the "OK'' button and the frame number will be automatically calculated. Total Frames = (Deck end point - Deck start point)/Frame length.`
          );
        } else {
          totalFrames = '';
        }

        // if (!isNaN(totalFrames)) {
        //   totalFrames =
        //     (Ship.Deck.EndPoint.X - Ship.Deck.StartPoint.X) / frameLength;
        // }

        if (!isNaN(totalFrames)) {
          totalFrames = parseInt((deckLength / frameLength).toString());
        }

        let numberOfPixels = deckLength;

        // calculate negative frames
        // between 0 to first green marker
        let negativeFrames = parseInt((Ship.Deck.StartPoint.X / frameLength).toString());
        // console.log('----', [negativeFrames, frameLength]);

        let numberOfNegativePixels = Ship.Deck.StartPoint.X;

        let averageFrameLength = 0;
        let numberOfRemPixels = 0;

        let frameStart = 1;
        let endStart = 0;

        FramePositions = [];
        negativeFramePositions = [];

        for (let n = 1; n <= negativeFrames; n++) {
          var tempNumberOframes = negativeFrames - n;
          tempNumberOframes = tempNumberOframes + 1;
          if (n == 1) {
            averageFrameLength = numberOfNegativePixels / tempNumberOframes;
          } else {
            averageFrameLength = numberOfRemPixels / tempNumberOframes;
          }

          endStart = frameStart + Math.floor(averageFrameLength);
          endStart = endStart - 1;

          // collect frame positions in temporary array
          // console.log('framestart', frameStart);

          negativeFramePositions.push(frameStart);
          frameStart = endStart + 1;

          numberOfRemPixels = numberOfNegativePixels - frameStart;
        }

        // calculate positive frames
        // from first marker to end of image
        let positiveFrames = totalFrames - negativeFrames;
        let numberOfPositivePixels = deckLength - Ship.Deck.StartPoint.X;
        averageFrameLength = 0;
        numberOfRemPixels = 0;
        frameStart = 0;
        endStart = 0;
        positiveFramePositions = [];

        for (let n = 1; n <= positiveFrames; n++) {
          let tempNumberOframes = positiveFrames - n;
          tempNumberOframes = tempNumberOframes + 1;
          if (n == 1) {
            averageFrameLength = numberOfPositivePixels / tempNumberOframes;
          } else {
            averageFrameLength = numberOfRemPixels / tempNumberOframes;
          }

          endStart = frameStart + Math.floor(averageFrameLength);
          endStart = endStart - 1;

          // collect frame positions in temporary array
          positiveFramePositions.push(frameStart + Ship.Deck.StartPoint.X);
          frameStart = endStart + 1;

          numberOfRemPixels = numberOfPositivePixels - frameStart;
        }

        // console.log('Updating related zones for individual frames.');

        let FrameCount = 1;
        _yPoint = FirstRedMarker.Y;

        if (Ship.Deck.StartPoint.X > 5 && Ship.Deck.EndPoint.X > Ship.Deck.StartPoint.X) {
          // Check frame count for valid deck positions only
          // _startPoint = FramePositions[0] + (Ship.Deck.StartPoint.X - 1);
          // _endPoint = FramePositions[1] + (Ship.Deck.StartPoint.X - 1) - 1;
          _startPoint = negativeFramePositions[0];
          _endPoint = negativeFramePositions[1];

          // add first frame element to json result
          Ship.Frames[0].Frame.ZoneNumber = 1;
          Ship.Frames[0].Frame.FrameNumber = 1 - negativeFramePositions.length;
          Ship.Frames[0].Frame.StartPoint.X = _startPoint;
          Ship.Frames[0].Frame.StartPoint.Y = _yPoint;
          Ship.Frames[0].Frame.EndPoint.X = _endPoint;
          Ship.Frames[0].Frame.EndPoint.Y = _yPoint;

          // FrameCount = Number(
          //   (Ship.Deck.EndPoint.X - Ship.Deck.StartPoint.X) / frameLength
          // );
        }

        if (negativeFramePositions.length > 0) {
          for (let _F = 2; _F <= negativeFramePositions.length; _F++) {
            _startPoint = negativeFramePositions[_F - 1];
            _endPoint = negativeFramePositions[_F];
            if (_endPoint > Ship.Deck.StartPoint.X || _F == negativeFramePositions.length) {
              _endPoint = Ship.Deck.StartPoint.X;
            }
            // add other frame elements to json result
            Ship.Frames.push({
              Frame: {
                ZoneNumber: getZoneNumberByFrame(_startPoint, Ship),
                FrameNumber: _F - negativeFramePositions.length,
                StartPoint: {
                  X: _startPoint,
                  Y: _yPoint,
                },
                EndPoint: {
                  X: _endPoint,
                  Y: _yPoint,
                },
              },
            });
          }
        }

        if (positiveFramePositions.length > 0) {
          for (let _F = 1; _F <= positiveFramePositions.length; _F++) {
            _startPoint = positiveFramePositions[_F - 1];
            _endPoint = positiveFramePositions[_F];
            if (_endPoint > canvasShipImg.width || _F == positiveFramePositions.length) {
              _endPoint = canvasShipImg.width;
            }
            // add other frame elements to json result
            Ship.Frames.push({
              Frame: {
                ZoneNumber: getZoneNumberByFrame(_startPoint, Ship),
                FrameNumber: _F,
                StartPoint: {
                  X: _startPoint,
                  Y: _yPoint,
                },
                EndPoint: {
                  X: _endPoint,
                  Y: _yPoint,
                },
              },
            });
          }
        }
      } else {
        console.log('frames not found.');
      }
    } else {
      console.log("zones not found, frame's searching skipped...");
    }
  } else {
    console.log('deck not found, zones and frames searching skipped...');
  }

  /////////////////////////////////////////////////////////////////////////////
  // Continue to detect center points

  // console.log('Scanning for center points (yellow markers).');
  startX = 0;
  endX = shipImage.width;

  // set center 20% height to scan
  startY = Number(canvasShipImg.height * 0.4);
  endY = Number(canvasShipImg.height * 0.7);

  // find yellow markers
  for (let _X = startX; _X <= endX; _X++) {
    for (let _Y = startY; _Y <= endY; _Y++) {
      // get color
      let p = c.getImageData(_X, _Y, 1, 1).data;
      let color = ('000000' + rgbToHex(p[0], p[1], p[2])).slice(-6);
      color = color.toUpperCase();

      // Get Yellow Start Color
      if (Constants.ColorYellow.indexOf(color) >= 0) {
        if (Ship.Center.StartPoint.X == 0) {
          Ship.Center.StartPoint.X = _X;
          Ship.Center.StartPoint.Y = _Y;
          _Y = _Y + MarkerWidth;
          startY = _Y + MarkerWidth;
        } else {
          Ship.Center.EndPoint.X = _X;
          Ship.Center.EndPoint.Y = _Y;
          break;
        }
      }
    }
    if (Ship.Center.StartPoint.X > 0 && Ship.Center.EndPoint.X > 0) {
      // console.log(
      //   'center points found at ' +
      //     Ship.Center.StartPoint.X +
      //     ' to ' +
      //     Ship.Center.EndPoint.X +
      //     '...'
      // );
      break;
    }
  }

  console.log('Full scanning completed.');

  let finalData = JSON.parse(JSON.stringify(Ship, null, 4));
  // }),
  //             node.expandAll(),
  // $(".actionButton").css("display", ""),
  // console.log('final result', finalData);
  // const {Zones, Deck, Center, Frames} = finalData;
  // console.log(Frames);
  // console.log('final result zones', [Zones, Deck, Center]);

  return finalData;
};

/////// Misc Functions

function rgbToHex(r, g, b) {
  if (r > 255 || g > 255 || b > 255) throw 'Invalid color component';
  return ((r << 16) | (g << 8) | b).toString(16);
}

function getZoneNumberByFrame(frameStartPoint, Ship) {
  let ZoneOfFrame = 0;
  let zoneCount = Ship.Zones.length;
  for (let i = 0; i < zoneCount; i++) {
    let zoneStartPoint = Ship.Zones[i].Zone.StartPoint.X;
    let zoneEndPoint = Ship.Zones[i].Zone.EndPoint.X;

    if (frameStartPoint >= zoneStartPoint && frameStartPoint <= zoneEndPoint) {
      ZoneOfFrame = Ship.Zones[i].Zone.ZoneNumber;
      break;
    }
  }
  return ZoneOfFrame;
}
